import LogoutButton from './LogoutButton.container';

export default LogoutButton;
